/* Carrousel du récit défilant : synchronise l'indicateur d'étapes avec
   le défilement, et permet d'aller directement à une étape.
   Délégation sur le document : la section peut être re-rendue par
   l'éditeur de thème sans que les écouteurs soient perdus. */
(function () {
  function media(dot) {
    var story = dot.closest('.lf-story');
    return story ? story.querySelector('.lf-story__media') : null;
  }

  /* Fleches : un cran a chaque appui. */
  document.addEventListener('click', function (e) {
    var fleche = e.target.closest ? e.target.closest('.lf-story__arrow') : null;
    if (!fleche) return;
    var story = fleche.closest('.lf-story');
    var m = story ? story.querySelector('.lf-story__media') : null;
    if (!m) return;
    var sens = fleche.classList.contains('lf-story__arrow--prev') ? -1 : 1;
    m.scrollBy({ left: sens * m.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('.lf-story__dot') : null;
    if (!dot) return;
    var m = media(dot);
    if (!m) return;
    var figs = m.querySelectorAll('.lf-story__figure');
    var cible = figs[parseInt(dot.getAttribute('data-lf-story-dot'), 10)];
    if (!cible) return;
    var d = cible.getBoundingClientRect().left - m.getBoundingClientRect().left;
    m.scrollTo({ left: m.scrollLeft + d, behavior: 'smooth' });
  });

  function brancher(story) {
    var m = story.querySelector('.lf-story__media');
    var nav = story.querySelector('[data-lf-story-nav]');
    if (!m || !nav || m.dataset.storyNavBound) return;
    m.dataset.storyNavBound = '1';

    function actif() {
      var figs = [].slice.call(m.querySelectorAll('.lf-story__figure'));
      var mr = m.getBoundingClientRect();
      var centre = mr.left + mr.width / 2;
      var best = 0, dmin = Infinity;
      figs.forEach(function (f, i) {
        var r = f.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - centre);
        if (d < dmin) { dmin = d; best = i; }
      });
      nav.querySelectorAll('.lf-story__dot').forEach(function (dot) {
        dot.classList.toggle('is-active', parseInt(dot.getAttribute('data-lf-story-dot'), 10) === best);
      });

      /* Une fleche en bout de course s'efface : elle ne promet pas un
         cran qui n'existe pas. */
      var prev = story.querySelector('[data-lf-story-prev]');
      var next = story.querySelector('[data-lf-story-next]');
      var reste = m.scrollWidth - m.clientWidth;
      if (prev) prev.classList.toggle('is-hidden', m.scrollLeft <= 4);
      if (next) next.classList.toggle('is-hidden', m.scrollLeft >= reste - 4);
    }
    m.addEventListener('scroll', actif, { passive: true });
    window.addEventListener('resize', actif, { passive: true });
    actif();
  }

  function boot() {
    document.querySelectorAll('.lf-story--carousel').forEach(brancher);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
